import { object, string, number, array } from 'yup';

import useCredentials from 'api/hook/useCredentials';

import { baseAxios, handleError } from 'api';
import { useQuery } from '@tanstack/react-query';

const contactScheme = object({
  company: string().min(4).required(),
  address1: string().min(2).required(),
  // address2: string(),
  district: string().min(2).required(),
  area: string().min(2).required(),
  province: string().min(3).required(),
  zipcode: string().min(5).required(),
  prefix: string().oneOf(['MR.', 'MS.', 'MRS.', 'MISS']),
  name: string().min(2).required(),
  lastname: string().min(2).required(),
  idCard: string().min(13).required(),
  phone: string().min(9).max(10).required(),
});

const DiscountScheme = object({
  '3m': number().required(),
  '6m': number().required(),
  '1y': number().required(),
  '15m': number().required(),
});

// eslint-disable-next-line no-unused-vars
const userScheme = object({
  email: string().email().required(),
  credential: object({
    password: string().min(8).required(),
    salt: string(),
    refreshToken: array().of(string()),
  }),
  contact: contactScheme,
  roles: array().of(number()),
  discount: DiscountScheme,
});

/**
 * @typedef {import('yup').InferType<typeof userScheme>} Member
 */

/**
 * @return {import('@tanstack/react-query').UseQueryResult<Member, any>}
 */
export function useUser(id) {
  const authAxios = useCredentials();

  return useQuery({
    queryKey: ['user', id],
    queryFn: () =>
      baseAxios(authAxios, {
        url: 'admin/user/' + id,
      }),
    onError: handleError,
  });
}
